import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDocTwistAiSearch(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M98.95 88.134c6.428-1.244 10.625-7.466 9.371-13.895L50.155 85.537c1.244 6.429-2.953 12.64-9.372 13.894l58.166-11.297Z"
        fill="#E2E8F0"
      />
      <path
        d="M73.757 20.596c6.429-1.244 12.64 2.953 13.894 9.372 2.262 11.633-4.858 37.16-2.597 48.794 1.245 6.43 7.466 10.626 13.895 9.372L40.783 99.431c-6.43 1.245-12.64-2.952-13.895-9.371-2.262-11.634 4.859-37.162 2.597-48.795-1.244-6.429-7.466-10.626-13.894-9.372l58.166-11.297Z"
        fill="#F1F5F9"
      />
      <path
        d="M84.902 77.977a.8.8 0 0 1 .937.633c1.16 5.994 6.962 9.908 12.956 8.74a.8.8 0 0 1 .307 1.57c-6.863 1.338-13.505-3.142-14.833-10.005a.8.8 0 0 1 .633-.938Z"
        fill="#0F172A"
      />
      <path
        d="M84.965 24.457a11.833 11.833 0 0 0-11.208-3.861L15.59 31.893c6.43-1.244 12.641 2.953 13.895 9.372.336 1.709.464 3.723.445 5.945l41.397-8.038c-1.244-6.43 2.953-12.641 9.372-13.895l4.257-.83.01.01Z"
        fill="#E2E8F0"
      />
      <path
        d="M15.59 31.893C9.171 33.138 4.974 39.36 6.218 45.788l58.167-11.297c-1.245-6.43 2.953-12.64 9.371-13.895L15.59 31.893Z"
        fill="#F1F5F9"
      />
      <path
        d="M73.603 19.801a.8.8 0 0 1 .307 1.57c-5.986 1.17-9.9 6.963-8.74 12.958a.8.8 0 0 1-.632.937l-22.102 4.296a.8.8 0 1 1-.304-1.57l21.34-4.149c-.852-6.575 3.543-12.755 10.131-14.042Z"
        fill="#0F172A"
      />
      <path
        d="M75.697 61.653a.8.8 0 0 1 .306 1.57l-40.717 7.91a.8.8 0 1 1-.304-1.57l40.715-7.91ZM75.046 73.859a.8.8 0 0 1 .305 1.57l-40.717 7.9a.8.8 0 1 1-.304-1.57l40.716-7.9ZM75.599 79.784a.8.8 0 0 1 .305 1.57l-40.717 7.91a.8.8 0 1 1-.304-1.57l40.715-7.91ZM75.698 67.588a.8.8 0 0 1 .305 1.57l-40.717 7.9a.8.8 0 1 1-.304-1.57l40.716-7.9ZM76.892 55.392a.8.8 0 1 1 .305 1.57L53.19 61.623a.8.8 0 1 1-.304-1.57l24.006-4.661ZM77.88 48.479a.8.8 0 1 1 .305 1.57l-25.143 4.88a.8.8 0 0 1-.304-1.572l25.142-4.878ZM77.88 41.566a.8.8 0 1 1 .305 1.57l-25.29 4.909a.8.8 0 1 1-.306-1.57l25.291-4.909Z"
        fill="#B3C0D0"
      />
      <path
        d="M43.905 49.716a.997.997 0 0 1 .811.18l.007.005.008.004.006.004a1 1 0 0 1 .385.756v.001l.36 10.855v.005c.004.528-.406.889-.787.969l-4.77 1.004a1.057 1.057 0 0 1-.295.021.957.957 0 0 1-.68-.333l-.003-.002-3.206-3.854a.989.989 0 0 1-.18-.972 1.01 1.01 0 0 1 .743-.654l2.222-.467-.186-5.5v-.001a1.01 1.01 0 0 1 .796-1.017l4.77-1.004Zm-4.09 8.53.131 3.975 4.08-.858-2.835-3.407-1.376.29Zm-2.86.596 1.695 2.038-.078-2.379-1.618.34ZM39.6 51.9l.173 5.08 1.308-.274a1.01 1.01 0 0 1 .88.239l.095.097.002.001 2.115 2.54L43.886 51l-4.286.902Z"
        fill="#78B441"
      />
      <path
        d="m95.755 42.318 17.198 14.339a3.794 3.794 0 1 1-5.083 5.623L91.873 46.613l3.882-4.295Z"
        fill="#007A5F"
      />
      <path d="m101.161 46.825.51 9.384-9.798-9.596 3.882-4.295 5.406 4.507Z" fill="#00664F" />
      <path
        d="m101.16 46.825.511 9.384-9.798-9.596 3.882-4.295 5.405 4.507Zm-7.07-.28 5.759 5.642-.25-4.58-3.688-3.076-1.821 2.015Z"
        fill="#00664F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78.938 51.224c7.763 3.974 17.277.903 21.252-6.86 3.974-7.761.903-17.276-6.86-21.25-7.762-3.975-17.277-.904-21.25 6.859-3.975 7.762-.904 17.276 6.858 21.25Z"
        fill="#78B441"
      />
      <path
        d="M97.71 37.428c0 6.25-5.066 11.317-11.316 11.317-6.25 0-11.316-5.067-11.316-11.316 0-6.25 5.066-11.317 11.316-11.317 6.25 0 11.317 5.067 11.317 11.317Z"
        fill="#CAE8DF"
      />
      <path
        d="M76.91 37.428a9.484 9.484 0 0 1 9.484-9.484.8.8 0 1 1 0 1.6 7.885 7.885 0 0 0-7.885 7.884.8.8 0 1 1-1.6 0Z"
        fill="#fff"
      />
      <path
        d="M74.278 37.428c0-6.691 5.424-12.116 12.116-12.116a.8.8 0 1 1 0 1.6c-5.808 0-10.516 4.709-10.516 10.517s4.708 10.516 10.516 10.516a.8.8 0 1 1 0 1.6c-6.692 0-12.116-5.425-12.116-12.117Z"
        fill="#0F172A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m18.949 73.746-.522-1.607a1.239 1.239 0 0 0-.786-.792l-1.595-.526c-.378-.122-.378-.662 0-.792l1.595-.525c.37-.122.665-.42.786-.793l.522-1.606c.12-.381.658-.381.786 0l.522 1.606c.12.374.416.67.786.793l1.595.525c.378.122.378.663 0 .792l-1.595.526c-.37.122-.665.419-.786.792l-.522 1.607c-.12.38-.657.38-.786 0Zm-5.942 11.996-.983-3.032a2.324 2.324 0 0 0-1.482-1.492l-3.009-.99c-.71-.236-.71-1.25 0-1.486l3.009-.99a2.325 2.325 0 0 0 1.482-1.493l.983-3.03c.234-.717 1.24-.717 1.474 0l.983 3.03a2.325 2.325 0 0 0 1.481 1.493l3.01.99c.71.236.71 1.25 0 1.486l-3.01.99a2.325 2.325 0 0 0-1.481 1.492l-.983 3.032c-.235.716-1.24.716-1.474 0Z"
        fill="#007A5F"
      />
    </svg>
  )
}
export default wrapIllustration(SvgDocTwistAiSearch)
